export const blockIconsActionFavoriteBorder = (
	<span className='material-symbols-outlined'>favorite_border</span>
);
